import { render, staticRenderFns } from "./JobStatusChip.vue?vue&type=template&id=9b901f76&"
import script from "./JobStatusChip.vue?vue&type=script&lang=js&"
export * from "./JobStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports